import styled from 'styled-components';

const InfoBox = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 6px;
  padding: 8px;
  font-size: 13px;
  line-height: 15px;
  font-family: ManropeLight, sans-serif;
  color: ${(props) => props.theme.colors.black};
  cursor: default;
  max-width: 400px;

  b {
    font-weight: bold;
    margin-right: 3px;
  }

  button {
    margin-top: 10px;
    display: block;
    width: 100%;
    text-align: center;
  }

  button:hover {
    color: ${(props) => props.theme.colors.orange};
    font-weight: bold;
  }
`;

const VehicleMarkerS = styled.div`
  button {
    border: 2px solid transparent;
    border-radius: 50px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    width: 33px;
    height: 33px;
  }

  .active-marker {
    border: 2px solid ${(props) => props.theme.colors.orange};
  }
`;

export default { InfoBox, VehicleMarkerS };
